<template>
  <div class="main-body">

    <div class="header">老人核减列表</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                ref="table" border stripe v-loading="loading">

        <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="200" :formatter="getIdCardStr"></el-table-column>
        <el-table-column prop="cutReason" label="核减原因" width="300" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getTime" label="注册时间" width="150"></el-table-column>
        <el-table-column prop="zoneName" label="所在区域" width="300" ></el-table-column>
        <el-table-column prop="homeAddress" label="住址" width="300"  :formatter="getAddress"></el-table-column>


        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
            <el-button type="primary" size="mini" @click="handleRemove(scope.row)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page" >
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <CutAdd ref="myCutAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></CutAdd>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree"

import CutAdd from "./CutAdd";

export default {
  name: "Role",
  data() {
    return {

      loading: false,
      showModalAdd: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,


      zoneValue:[],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },

    }
  },
  components: {
    elSelectTree,CutAdd
  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {

      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
      this.datetimerangeValue = [start, end];

      this.getZonList();
      this.getList();

    },

    getZonList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              //console.log(data);
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;
              //this.getList();

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    getZoneValue(val) {
      this.zoneCode = val
    },
    getTime(row,index,column){
      return timefilters(column)
    },
    getIdCardStr(row,index,column){
      let str = "";
      if(column && column.length == 18){
        str = column.substring(0,6)+"********"+column.substring(14,18);
      }else{
        str = column;
      }
      return str;
    },
    getAddress(row,index,column){
      let str = "";
      if(column && column.length > 7){
        str = column.substring(0,column.length-6)+"******";
      }else{
        str = column;
      }
      return str;
    },



    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myCutAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyAdm/GovCutPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          zoneCode:this.zoneCode
        }
      }).then((response) => {

        this.loading=false;
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{this.$refs.table.doLayout()});

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handleDelete(row){
      this.$confirm('是否删除此老人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ElderlyAdm/GovDelete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            elderlyCode:row.elderlyCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },
    handleRemove(row){
      this.$confirm('是否恢复此老人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ElderlyAdm/GovCutRemove",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            elderlyCode:row.elderlyCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },



  }
}
</script>

<style lang="scss" scoped>

</style>
